import { useFormValues } from '../core';
// Imported by path, not through the utils barrel, to keep hooks and utils acyclic.
import { findActiveFieldWarning } from '../utils/findActiveFieldWarning';
import type { FormFieldWarning, FormInitialValues, SingleFormField } from '../typings';

/**
 * The field's active warning, or undefined. Re-derives on every value change,
 * and is deliberately not gated on `touched` so a saved or pre-filled date
 * warns on mount.
 */
export const useFieldWarning = (
  field: SingleFormField,
): FormFieldWarning | undefined => {
  const values = useFormValues<FormInitialValues>();

  return findActiveFieldWarning(field, values[field.fieldId]);
};
